import { IOptionType } from 'props';
import { Dispatch, SetStateAction, useState } from 'react';
import { IoClose } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context';
import { DropDownNavBar } from '../DropDownNavBar';
import { Container } from './styles';
import { ProfileType, TypeUser } from '../../types/enums';
import { UserController } from '../../controller/UserController';
import { useAlert } from '../../hooks/useAlert';

export interface IPropsStyles {
  isVisible: boolean;
}

type MenuMobileProps = {
  menuIsVisible: boolean;
  setMenuIsVisible: Dispatch<SetStateAction<boolean>>;
  typeHeader:
  | 'default'
  | 'loggedOut'
  | 'company'
  | 'user'
  | 'collaborator'
  | 'plaintiff'
  | 'provider';
};

interface ActionsType {
  title: string;
  linkTo: string;
}

export function MenuMobile({ menuIsVisible, setMenuIsVisible, typeHeader }: MenuMobileProps) {
  const alert = useAlert();
  const { logout, user } = useAuth();
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);

  const toggleDropdown = (name: string) => {
    setOpenDropdown((prevOpenDropdown) => (prevOpenDropdown === name ? null : name));
  };

  const handleLogout = () => {
    logout();
  };

  const getOptions = () => {
    if ([TypeUser.COMPANY, TypeUser.ADM, TypeUser.USER].includes(user.type)) {
      const companyOptions: IOptionType = {
        name: 'Empresa',
        type: 'company',
      };
      const solicitaitonOptions: IOptionType = {
        name: 'Solicitação',
        type: 'solicitation',
      };
      const demandOptions: IOptionType = {
        name: 'Demandas',
        type: 'demand',
      };
      // const reportOptions: IOptionType = {
      //   name: 'Relatório',
      //   type: 'report',
      // };
      return [companyOptions, solicitaitonOptions, demandOptions];
    }
    if (user.type === TypeUser.USER) {
      const demandOptions: IOptionType = {
        name: 'Demandas',
        type: 'demand',
      };
      // const reportOptions: IOptionType = {
      //   name: 'Relatório',
      //   type: 'report',
      // };
      return [demandOptions];
    }
    if (user.collaboratorInfo?.profileType === ProfileType.REQUESTER) {
      const solicitaitonOptions: IOptionType = {
        name: 'Solicitação',
        type: 'solicitation',
      };
      return [solicitaitonOptions];
    }
    if (user.collaboratorInfo?.profileType === ProfileType.APPROVER) {
      const demandOptions: IOptionType = {
        name: 'Demandas',
        type: 'demand',
      };
      // const reportOptions: IOptionType = {
      //   name: 'Relatório',
      //   type: 'report',
      // };
      return [demandOptions];
    }
    return [];
  };

  const getProfile = () => {
    const myProfile: ActionsType = {
      title: 'Meu perfil',
      linkTo: user.type === TypeUser.USER ? '/naturalPersonAccount' : '/legalPersonAccount',
    };
    const notification: ActionsType = {
      title: 'Configuração Notificações',
      linkTo: '/notification',
    };
    const myValues: ActionsType = {
      title: 'Meus valores',
      linkTo: '/myvalues',
    };
    const wallet: ActionsType = {
      title: 'Carteira',
      linkTo: '/wallet',
    };
    return [myProfile, notification, myValues, wallet];
  };

  const handleRedirectTimeSheet = async () => {
    await UserController.timeSheetSigin()
      .then((res) => {
        const urlRedirect = new URL(res);
        window.open(urlRedirect, '_blank');
      })
      .catch(() => {
        alert.show({
          message: 'Não foi possível realizar o redirecionamento para o timesheet',
          type: 'error',
        });
      });
  };

  return (
    <Container isVisible={menuIsVisible}>
      <div className="containerContent">
        <div className="content">
          <div className="header">
            <IoClose className="close" size={45} onClick={() => setMenuIsVisible(false)} />
          </div>
          <nav>
            {typeHeader === 'loggedOut' && (
              <ul>
                <li>
                  <Link to="/register">Cadastrar-se</Link>
                </li>
                <li>
                  <Link to="/login">Entrar</Link>
                </li>
              </ul>
            )}
            {typeHeader !== 'loggedOut' && typeHeader !== 'default' && (
              <ul>
                <li>
                  <Link to="/schedule">Agenda</Link>
                </li>
                {/* <li>
                  <Link to="" onClick={handleRedirectTimeSheet}>TimeSheet</Link>
                </li> */}

                {getOptions().map((option) => {
                  return (
                    <li key={option.name}>
                      <DropDownNavBar
                        name={option.name}
                        typeHeader={option.type}
                        isOpen={openDropdown === option.name}
                        toggleDropdown={toggleDropdown}
                      />
                    </li>
                  );
                })}
                {([TypeUser.COMPANY, TypeUser.ADM, TypeUser.USER].includes(user.type) ||
                  user.collaboratorInfo?.profileType === ProfileType.APPROVER) && (
                    <li>
                      <Link to="/financial">Relatório</Link>
                    </li>
                  )}
                <li>
                  {user.type !== TypeUser.COLLABORATOR && (
                    <DropDownNavBar
                      name="Perfil"
                      isOpen={openDropdown === 'Perfil'}
                      toggleDropdown={toggleDropdown}
                      profiles={getProfile().map((item) => item)}
                    />
                  )}
                </li>

                <li>
                  <Link
                    to="/login"
                    onClick={() => handleLogout()}
                    style={{
                      textDecoration: 'none',
                    }}>
                    Sair
                  </Link>
                </li>
              </ul>
            )}
          </nav>
        </div>
      </div>
    </Container>
  );
}
